import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=28204a7c&scoped=true&lang=html&"
import script from "./UsersForm.vue?vue&type=script&lang=js&"
export * from "./UsersForm.vue?vue&type=script&lang=js&"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=28204a7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28204a7c",
  null
  
)

export default component.exports